/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import2 from '../../ui-elements/icon/icon.component';
import * as import3 from '../../ui-elements/spinner/spinner.component.ngfactory';
import * as import4 from '../../ui-elements/spinner/spinner.component';
import * as import5 from '../../html-utils/html.pipe';
import * as import6 from '@angular/platform-browser';
import * as import7 from '@angular/common';
import * as import8 from './button.component';
import * as import9 from '../../ui-elements/touchable.directive';
import * as import10 from 'ng2-translate/src/translate.pipe';
import * as import11 from 'ng2-translate/src/translate.service';
import * as import12 from '../../orchestration/session.model';
import * as import13 from '../../orchestration/responsive.service';
const styles_ButtonComponent:any[] = ([] as any[]);
export const RenderType_ButtonComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ButtonComponent,
  data: {}
}
);
function View_ButtonComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,':svg:svg',[[
        'class',
        'underlay'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,':svg:defs',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,':svg:filter',[
      [
        'color-interpolation-filters',
        'sRGB'
      ]
      ,
      [
        'id',
        'underlay-black-white-threshold'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:feColorMatrix',[
      [
        'type',
        'matrix'
      ]
      ,
      [
        'values',
        '\n                0.3333 0.3333 0.3333 0 0\n                0.3333 0.3333 0.3333 0 0\n                0.3333 0.3333 0.3333 0 0\n                0      0      0      1 0'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,':svg:feComponentTransfer',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:feFuncR',[
      [
        'tableValues',
        '1 1 1 1 0.65'
      ]
      ,
      [
        'type',
        'discrete'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:feFuncG',[
      [
        'tableValues',
        '1 1 1 1 0.65'
      ]
      ,
      [
        'type',
        'discrete'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:feFuncB',[
      [
        'tableValues',
        '1 1 1 1 0.65'
      ]
      ,
      [
        'type',
        'discrete'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,':svg:rect',[
      [
        'height',
        '100%'
      ]
      ,
      [
        'width',
        '100%'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(null as any));
}
function View_ButtonComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'content-main-icon'
      ]
    ],(null as any),(null as any),(null as any),import1.View_IconComponent_0,import1.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import2.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.icon;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_ButtonComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-spinner',[[
        'class',
        'face-spinner'
      ]
    ],(null as any),(null as any),(null as any),import3.View_SpinnerComponent_0,import3.RenderType_SpinnerComponent)),
    import0.ɵdid(49152,(null as any),0,import4.SpinnerComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export function View_ButtonComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import5.HtmlPipe,[import6.DomSanitizer]),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ButtonComponent_1)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),27,'div',[
      [
        'class',
        'face'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import8.ButtonComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import7.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'hovered',
      'native'
    ]
    ),
    import0.ɵdid(4210688,(null as any),0,import9.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),18,'div',[[
        'class',
        'content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'content-main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ButtonComponent_2)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'content-main-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'content-main-label-text'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import10.TranslatePipe,[
      import11.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ButtonComponent_3)),
    import0.ɵdid(16384,(null as any),0,import7.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import8.ButtonComponent = v.component;
    const currVal_0:any = (co.style === co.ButtonStyle.RAISED);
    ck(v,2,0,currVal_0);
    const currVal_1:any = 'face';
    const currVal_2:any = ck(v,6,0,co.hovered,co.responsiveService.isApp);
    ck(v,5,0,currVal_1,currVal_2);
    const currVal_3:any = co.icon;
    ck(v,14,0,currVal_3);
    const currVal_5:any = co.showSpinner;
    ck(v,30,0,currVal_5);
  },(ck,v) => {
    var co:import8.ButtonComponent = v.component;
    const currVal_4:any = import0.ɵunv(v,20,0,ck(v,22,0,import0.ɵnov(v,0),import0.ɵunv(v,20,0,import0.ɵnov(v,21).transform(co.label,co.translationParams))));
    ck(v,20,0,currVal_4);
  });
}
function View_ButtonComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-button',([] as any[]),[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },View_ButtonComponent_0,RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import8.ButtonComponent,[
      import0.ElementRef,
      import12.SessionModel,
      import0.ChangeDetectorRef,
      import13.ResponsiveService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
export const ButtonComponentNgFactory:import0.ComponentFactory<import8.ButtonComponent> = import0.ɵccf('woa-button',import8.ButtonComponent,View_ButtonComponent_Host_0,{
  overrideFlatBackgroundColor: 'overrideFlatBackgroundColor',
  overrideFlatForegroundColor: 'overrideFlatForegroundColor',
  overrideOutlineBackgroundColor: 'overrideOutlineBackgroundColor',
  overrideOutlineForegroundColor: 'overrideOutlineForegroundColor',
  overrideOutlineBorderColor: 'overrideOutlineBorderColor',
  overrideRaisedBackgroundColor: 'overrideRaisedBackgroundColor',
  overrideRaisedForegroundColor: 'overrideRaisedForegroundColor',
  label: 'label',
  translationParams: 'translationParams',
  icon: 'icon',
  showSpinner: 'showSpinner',
  layout: 'layout',
  disabled: 'disabled',
  invisible: 'invisible',
  hovered: 'hovered',
  tier: 'tier',
  prominence: 'prominence',
  connotation: 'connotation',
  shape: 'shape',
  style: 'style'
}
,{},[
  '*',
  '[slot=after-label]'
]
);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/buttons/button/button.component.ngfactory.ts